import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { isAuthSelector, levelSelector } from "../Recoil/Atom/authState";
import SuperLevel from "./SuperLevel";
import Post from "../pages/Post";
import NotFound from "../pages/NotFound";
import ManagerLevel from "./ManagerLevel";
import OfficerLevel from "./OfficerLevel";
import BoardManagerLevel from "./BoardManagerLevel";

const ProtectLayout = () => {
  const isAuth = useRecoilValue(isAuthSelector);
  const userLevel = useRecoilValue(levelSelector);

  if (isAuth) {
    switch (userLevel) {
      case 1:
        return <SuperLevel />;
      case 2:
        return <SuperLevel />;
      case 3:
        return <ManagerLevel />;
      case 4:
        return <OfficerLevel />;
      case 5:
        return <BoardManagerLevel />;
      default:
        return <NotFound />;
    }
  } else {
    const url = window.location.href;
    console.log(url);
    if (url.toLowerCase().indexOf("equipment/detail/") > -1) {
      const splitted = url.split("/");
      const uid = splitted[splitted.length - 1];
      return <Navigate to={`/Home/login/?l1=equipment&l2=detail&l3=${uid}`} replace />;
    }
    return <Navigate to={`/Home/login`} replace />;
  }
};

export default ProtectLayout;
